import * as React from 'react'
import { styleguide } from 'styleguide'

export default function({ className, color = 'illustrationLightBlue' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 251 251"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <circle id="chevron-circle-path-1" cx="194.5" cy="125.5" r="125.5" />
        <pattern
          id="chevron-circle-pattern-2"
          width="36.841299"
          height="36.841299"
          x="32.158701"
          y="-36.841299"
          patternUnits="userSpaceOnUse">
          <use
            xlinkHref="#chevron-circle-image-3"
            transform="scale(0.36841299,0.36841299)"
          />
        </pattern>
        <image
          id="chevron-circle-image-3"
          width="100"
          height="100"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
      <g
        id="chevron-circle-Desktop-Copy-4"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <g
          id="chevron-circle-Desktop-Home-Copy-9"
          transform="translate(-740.000000, -521.000000)">
          <g
            id="chevron-circle-Group-40"
            transform="translate(671.000000, 521.000000)">
            <g id="chevron-circle-Group-39-Copy-2">
              <g id="chevron-circle-Group-20-Copy-3">
                <g id="chevron-circle-Group-17">
                  <g id="chevron-circle-Oval-7-Copy">
                    <use
                      fill={styleguide.colors[color]}
                      xlinkHref="#chevron-circle-path-1"
                    />
                    <use
                      fill="url(#chevron-circle-pattern-2)"
                      xlinkHref="#chevron-circle-path-1"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/Illustrations/ChevronCircle.jsx